module.exports = __webpack_public_path__ + "img/line-chart.b4fd3245.svg";